/**
 * @public
 */
export enum NOTIFICATION_TYPE {
  COMMUNITY_ACCEPTED = 'community-accepted',
  COMMUNITY_REJECTED = 'community-rejected',
  COMMUNITY_JOINED = 'community-joined',
  NEW_PRAYER_ON_INTENTION = 'new-prayer-on-intention',
  NEW_PRAYER_ON_BIRTHDAY = 'new-prayer-on-birthday-intention',
  NEW_PRAYER_ON_ARRIVAL = 'new-prayer-on-arrival-intention',
  PROMOTED_TO_ROLE_ON_COMMUNITY = 'promoted-to-role-on-community',
  INTENTION_FINISHED = 'intention-finished',
  BIRTHDAY_INTENTION_FINISHED = 'birthday-intention-finished',
  ARRIVAL_INTENTION_FINISHED = 'arrival-intention-finished',
  NEW_COMMENT_ON_PUBLICATION = 'new-comment-on-publication',
}

/**
 * @public
 */
export enum NOTIFICATION_CATEGORY {
  GENERAL = 'general',
  PUBLICATIONS = 'publications',
  ANNOUNCEMENTS = 'announcements',
}

/**
 * @public
 */
export enum NOTIFICATION_MEDIUM {
  EMAIL = 'email',
  PUSH = 'push',
}

/**
 * @public
 */
export enum GENERAL_NOTIFICATION_SETTINGS {
  DIGEST = 'digest',
  NEWSLETTER = 'newsletter',
  ON_COMMENT_ANSWER = 'on_comment_answer',
  ON_COMMUNITY_JOINED = 'on_community_joined',
  ON_PRIVATE_MESSAGE = 'on_private_message',
  ON_INTENTION_FINISHED = 'on_intention_finished',
  ON_INTENTION_WATCHMAN = 'on_intention_watchman',
  ON_USER_CATCHUP = 'on_user_catchup',
  ON_GODSON_JOINED = 'on_godson_joined',
  ON_RETREAT_ENDED = 'on_retreat_ended',
}

export const newPrayerNotificationTypes = [
  NOTIFICATION_TYPE.NEW_PRAYER_ON_ARRIVAL,
  NOTIFICATION_TYPE.NEW_PRAYER_ON_BIRTHDAY,
  NOTIFICATION_TYPE.NEW_PRAYER_ON_INTENTION,
] as const

export const anyIntentionFinishedNotificationTypes = [
  NOTIFICATION_TYPE.INTENTION_FINISHED,
  NOTIFICATION_TYPE.BIRTHDAY_INTENTION_FINISHED,
  NOTIFICATION_TYPE.ARRIVAL_INTENTION_FINISHED,
] as const

export enum PUSH_EVENT_LABEL {
  CTA_ACCEPT_NOTIF = 'Cta-Accept-Notif',
  NEW_PUBLICATION = 'New-Publication',
  INTENTION_FINISHED = 'Intention-Finished',
  SETTINGS_PAGE = 'Settings-Page',
  PRAYER_WATCHMAN = 'Prayer-Watchman',
  JOIN_COMMUNITY = 'Join-Community',
}
